import { NotificationIdentifier } from '@evorait/pace-core';
import { createAction, props } from '@ngrx/store';
import { ContentResults } from '../../types/content-results';
import { FormIdentifier } from '../../types/form-identifier';
import { FormsConstants } from '../../types/forms-constants';
import { ODataSPQModel } from '../../types/service-part-questionnaire';

export const loadSpqDoc = createAction(
    '[Forms] SPQ: Load Doc',
    props<{
        form: FormIdentifier;
        notification: NotificationIdentifier;
        materialKey: string;
        language: string;
        materialNumber: string;
    }>(),
);

export const loadSpqDocSuccess = createAction(
    '[Forms] SPQ: Load Doc Success',
    props<{
        form: FormIdentifier;
        questionnaire: ODataSPQModel;
        notification: NotificationIdentifier;
        language: string;
        contentResults: ContentResults;
        materialKey: string;
        xml: string;
        email: string;
        lockedBy: string;
        materialNumber: string;
    }>(),
);

export const submitSpqDocSuccess = createAction(
    '[Forms] SPQ: Submit Doc Success',
    props<{
        form: FormIdentifier;
        notification: NotificationIdentifier;
        saveMode: FormsConstants.SUBMIT_STATUS;
    }>(),
);

export const cleanupSpqDocs = createAction(
    '[Forms] SPQ: Clean up saved data',
    props<{
        spqMaterials: Array<{ form: FormIdentifier; notificationId: NotificationIdentifier; materialKey: string }>;
    }>(),
);

export const updateDefectServicePartIdentificationField = createAction(
    '[Forms] SPW: Update defect service part',
    props<UpdateDefectServicePartIdentificationProps>(),
);

export type UpdateDefectServicePartIdentificationProps = Readonly<{
    xmlId: string;
    newValue: string;
}>;
